<template>
	<div class="flex flex-wrap gap-2">
		<slot />
	</div>
</template>
